/*
 * FunFungi · Packs como atajos (03-11-2026, test 1 / 3x2 / 5x3, pedido de Mau).
 * Un pack (dúo o Pack 4) no entra al carrito como producto: entran sus frascos sueltos, y así el 3x2 y el 5x3
 * (descuentos automáticos por frasco) calculan solos y 4 frascos cuestan lo mismo los armes como los armes.
 * Datos: `atajos` del metacampo funfungi.escalera_test (snippets/ff-colores.liquid lo imprime en #ff-escalera-datos).
 *
 * 1. Cambia en el camino cualquier /cart/add que traiga la variante de un pack (ficha, barra fija, test, «Agrégalos»,
 *    sugerencias del carrito de Kaching): FormData, JSON, URLSearchParams o texto de formulario, con `id` o `items[]`.
 * 2. Plan B: si un pack igual llega al carrito (otra ruta), agrega sus frascos y recién ahí saca el pack.
 * 3. En la ficha de un dúo o del Pack 4 (atajo con `regalo`): «Elige tu hongo de regalo». Cada opción lo incluye
 *    (dúo + 1 = 3 frascos = 3x2; 2 dúos + 1 = 5 = 5x3; Pack 4 + 1 = 5 = 5x3; 2 packs + 2 = 10, con `regalo_por_pack`), así que va en cada agregado desde el formulario
 *    principal de esa ficha (el que tiene `id` suelto y `product-id` del dúo). No va en JSON (Kaching, «Agrégalos»).
 * 3b. El Pack 4 (`regalo_siempre`) entra siempre con su regalo: si nadie lo eligió, una Melena (`regalo_defecto`).
 * 4. En la ficha de un pack se esconde «Comprar ahora» (iría directo al pago con el pack).
 * Marca el carrito con el atributo `_ff_atajo` (packs agregados, separados por « | ») para medir el test.
 * La ficha puede llegar después (landing «razones»): se arma también cuando aparece una escalera nueva.
 */
(function () {
  'use strict';
  if (window.FFAtajos) return;
  var nodo = document.getElementById('ff-escalera-datos');
  var datos = null;
  try { datos = JSON.parse((nodo && nodo.textContent) || 'null'); } catch (e) { datos = null; }
  if (!datos || !datos.atajos) return;

  var porVariante = {}, porProducto = {};
  Object.keys(datos.atajos).forEach(function (pid) {
    var a = datos.atajos[pid];
    a.producto = String(pid);
    porProducto[String(pid)] = a;
    if (a.variante) porVariante[String(a.variante)] = a;
  });
  var nombres = datos.nombres_frasco || {};
  var fetchOriginal = window.fetch;
  // Hongo de regalo elegido en la ficha del dúo.
  var regalo = { pack: null, variante: null, caja: null };

  function esPack(variante) { return porVariante[String(variante || '').replace(/\D/g, '')] || null; }
  function frascos(a, cantidad, props) {
    return a.variantes.map(function (v) {
      var it = { id: Number(v), quantity: cantidad };
      if (props && Object.keys(props).length) it.properties = props;
      return it;
    });
  }
  // Frascos de regalo de una opción: `regalo` por agregado (dúo: siempre 1) o por cada pack (`regalo_por_pack`, Pack 4).
  function cuantosRegalo(a, q) { return (Number(a.regalo) || 0) * (a.regalo_por_pack ? (Number(q) || 1) : 1); }
  function regaloPara(a, productId, q) {
    if (!a || !a.regalo || regalo.pack !== a || !regalo.variante) return [];
    if (!regalo.caja || !regalo.caja.isConnected) return []; // solo con el selector a la vista (no en otra ventana o compra rápida)
    if (String(productId || '') !== a.producto) return []; // solo el formulario de la ficha de ese dúo
    return [{ id: Number(regalo.variante), quantity: cuantosRegalo(a, q) }];
  }
  // Pack que se vende siempre con su regalo (`regalo_siempre`, Pack 4): si no viene elegido desde su ficha
  // (tarjetas, test, sugerencias de Kaching, «Agrégalos», plan B), entra el hongo por defecto (`regalo_defecto`, Melena).
  function regaloDefecto(a, q) {
    if (!a || !a.regalo_siempre || !a.regalo_defecto) return [];
    return [{ id: Number(a.regalo_defecto), quantity: cuantosRegalo(a, q) }];
  }
  function marcar(nombre) {
    try {
      var c = window.FFEscalera && window.FFEscalera.carrito && window.FFEscalera.carrito();
      var antes = (c && c.attributes && c.attributes._ff_atajo) || '';
      var lista = antes ? antes.split(' | ') : [];
      if (lista.indexOf(nombre) < 0) lista.push(nombre);
      fetchOriginal.call(window, '/cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _ff_atajo: lista.join(' | ').slice(0, 250) } })
      }).catch(function () {});
    } catch (e) {}
  }

  // --- 1. Cambiar el pedido en el camino ---
  // Lee pares [clave, valor] de un formulario (FormData o URLSearchParams): campos sueltos + artículos.
  function leerPares(pares) {
    var campos = [], suelto = null, items = {}, orden = [];
    pares.forEach(function (kv) {
      var k = kv[0], v = kv[1], m;
      if (k === 'id') { suelto = suelto || { properties: {} }; suelto.id = v; return; }
      if (k === 'quantity') { suelto = suelto || { properties: {} }; suelto.quantity = v; return; }
      if ((m = /^properties\[(.+)\]$/.exec(k))) { suelto = suelto || { properties: {} }; suelto.properties[m[1]] = v; return; }
      if ((m = /^items\[(\d+)\]\[(id|quantity)\]$/.exec(k))) {
        if (!items[m[1]]) { items[m[1]] = { properties: {} }; orden.push(m[1]); }
        items[m[1]][m[2]] = v; return;
      }
      if ((m = /^items\[(\d+)\]\[properties\]\[(.+)\]$/.exec(k))) {
        if (!items[m[1]]) { items[m[1]] = { properties: {} }; orden.push(m[1]); }
        items[m[1]].properties[m[2]] = v; return;
      }
      campos.push([k, v]);
    });
    var lista = (suelto && suelto.id ? [suelto] : []).concat(orden.map(function (n) { return items[n]; }));
    return { campos: campos, items: lista, suelto: !!(suelto && suelto.id) };
  }
  // Cambia los packs de una lista de artículos por sus frascos (+ el regalo, si corresponde). null si no hay packs.
  function expandir(items, conRegalo, productId) {
    var salida = [], pack = null, conRegaloFinal = false;
    items.forEach(function (it) {
      var a = esPack(it.id);
      if (!a) { salida.push(it); return; }
      var primero = !pack;
      pack = a;
      var q = Number(it.quantity || 1) || 1;
      frascos(a, q, it.properties).forEach(function (f) { salida.push(f); });
      var r = primero && conRegalo ? regaloPara(a, productId, q) : [];
      if (!r.length) r = regaloDefecto(a, q);
      if (r.length) { conRegaloFinal = true; salida.push(r[0]); }
    });
    return pack ? { items: salida, pack: pack, regalo: conRegaloFinal } : null;
  }
  function escribirPares(destino, campos, items) {
    campos.forEach(function (kv) { destino.append(kv[0], kv[1]); });
    items.forEach(function (it, i) {
      destino.append('items[' + i + '][id]', it.id);
      destino.append('items[' + i + '][quantity]', it.quantity || 1);
      Object.keys(it.properties || {}).forEach(function (p) { destino.append('items[' + i + '][properties][' + p + ']', it.properties[p]); });
    });
    return destino;
  }
  function cambiarCuerpo(cuerpo) {
    if (typeof URLSearchParams !== 'undefined' && cuerpo instanceof URLSearchParams) cuerpo = cuerpo.toString();
    // FormData (formulario de producto de Shrine, «Agrégalos»)
    if (typeof FormData !== 'undefined' && cuerpo instanceof FormData) {
      var pares = [];
      cuerpo.forEach(function (v, k) { pares.push([k, v]); });
      var l = leerPares(pares);
      var pid = cuerpo.get('product-id');
      var x = expandir(l.items, l.suelto, pid);
      if (!x) return null;
      return { cuerpo: escribirPares(new FormData(), l.campos, x.items), pack: x.pack, regalo: x.regalo };
    }
    if (typeof cuerpo !== 'string') return null;
    // JSON: { id, quantity } o { items: [...] } (Kaching, test, «Agrégalos»): sin regalo.
    var j = null;
    try { j = JSON.parse(cuerpo); } catch (e) { j = null; }
    if (j && typeof j === 'object') {
      var lista = j.items || (j.id ? [{ id: j.id, quantity: j.quantity, properties: j.properties }] : []);
      var y = expandir(lista, false);
      if (!y) return null;
      var copia = {};
      Object.keys(j).forEach(function (k) { if (k !== 'id' && k !== 'quantity' && k !== 'properties' && k !== 'items') copia[k] = j[k]; });
      copia.items = y.items;
      return { cuerpo: JSON.stringify(copia), pack: y.pack, json: true, regalo: false };
    }
    // Texto de formulario: id=…&quantity=…&properties[…]=… o items[0][id]=…
    if (/(^|&)(id|items%5B|items\[)/.test(cuerpo)) {
      var p = new URLSearchParams(cuerpo), pp = [];
      p.forEach(function (v, k) { pp.push([k, v]); });
      var lu = leerPares(pp);
      var z = expandir(lu.items, lu.suelto, p.get('product-id'));
      if (!z) return null;
      return { cuerpo: escribirPares(new URLSearchParams(), lu.campos, z.items).toString(), pack: z.pack, regalo: z.regalo };
    }
    return null;
  }

  function avisoRegalo(texto) {
    var c = regalo.caja && regalo.caja.querySelector('.ffa-regalo__aviso');
    if (c) { c.textContent = texto; c.hidden = !texto; }
  }
  window.fetch = function (recurso, opciones) {
    try {
      var url = typeof recurso === 'string' ? recurso : (recurso && recurso.url) || '';
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && opciones && opciones.body) {
        var r = cambiarCuerpo(opciones.body);
        if (r) {
          var nuevas = {};
          Object.keys(opciones).forEach(function (k) { nuevas[k] = opciones[k]; });
          nuevas.body = r.cuerpo;
          if (r.json || typeof r.cuerpo === 'string') {
            var h = new Headers(opciones.headers || {});
            h.set('Content-Type', r.json ? 'application/json' : 'application/x-www-form-urlencoded');
            nuevas.headers = h;
          }
          var p = fetchOriginal.call(this, recurso, nuevas);
          p.then(function (res) {
            if (res && res.ok) { avisoRegalo(''); marcar((r.pack.nombre || r.pack.producto) + (r.regalo ? ' + hongo gratis' : '')); }
            else if (r.regalo) avisoRegalo('No pudimos agregar todo (algún hongo puede estar agotado). Prueba con otro hongo de regalo o escríbenos.');
          }, function () {});
          return p;
        }
      }
    } catch (e) { /* si algo falla, sigue el pedido tal cual: el plan B lo arregla */ }
    return fetchOriginal.apply(this, arguments);
  };

  // --- 2. Plan B: un pack que llegó igual al carrito se cambia por sus frascos ---
  // Agrega primero los frascos y solo si resultó saca el pack (si falla, el pack queda: nada se pierde).
  // No toca regalos en $0, líneas de Kaching ni suscripciones. Uno a la vez y siempre con el carrito recién leído
  // (los avisos del carrito pueden llegar con una copia vieja, de antes de sacar el pack, y lo convertirían dos veces).
  // Ojo: Shopify cambia la llave (`key`) de la línea del pack cuando entran los frascos; por eso se vuelve a leer el
  // carrito antes de sacarlo, y los intentos se cuentan por variante (no por llave).
  var ocupado = false, intentos = {};
  function esKaching(it) { return !!(it.properties && Object.keys(it.properties).some(function (k) { return /^_+kaching/.test(k); })); }
  function propsPropias(it) {
    var o = {};
    Object.keys(it.properties || {}).forEach(function (k) { if (!/^_+kaching/.test(k) && it.properties[k] != null) o[k] = it.properties[k]; });
    return o;
  }
  function cantidadPack(c, vid) {
    return (c.items || []).reduce(function (t, it) { return t + (String(it.variant_id) === String(vid) && it.final_line_price > 0 && !esKaching(it) ? it.quantity : 0); }, 0);
  }
  function convertible(it) {
    return esPack(it.variant_id) && it.final_line_price > 0 && !it.selling_plan_allocation &&
      esKaching(it) === false && (intentos[it.variant_id] || 0) < 2;
  }
  function leerCarrito() {
    return fetchOriginal.call(window, '/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function normalizar(aviso) {
    if (ocupado || !((aviso && aviso.items) || []).some(convertible)) return;
    ocupado = true;
    var l = null, a = null;
    leerCarrito()
      .then(function (c) {
        l = (c.items || []).filter(convertible)[0];
        if (!l) return null;
        intentos[l.variant_id] = (intentos[l.variant_id] || 0) + 1;
        a = esPack(l.variant_id);
        var props = propsPropias(l), clave = JSON.stringify(props), antes = 0;
        // Con window.fetch (no el original): así el carrito de Kaching y la escalera se enteran del cambio.
        return window.fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: frascos(a, l.quantity, props).concat(regaloDefecto(a, l.quantity)) })
        }).then(function (r) {
          if (!r.ok) throw new Error('add');
          return leerCarrito();
        }).then(function (c2) {
          // La misma línea del pack, ahora con su llave nueva: misma variante y mismas propiedades (sin las de Kaching).
          antes = cantidadPack(c2, l.variant_id);
          var candidatas = (c2.items || []).filter(function (it) {
            return String(it.variant_id) === String(l.variant_id) && it.final_line_price > 0 && !esKaching(it);
          });
          var m = candidatas.filter(function (it) { return JSON.stringify(propsPropias(it)) === clave; })[0] || candidatas[0];
          if (!m) return null;
          return window.fetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: m.key, quantity: Math.max(0, m.quantity - l.quantity) })
          }).then(function (r) { return r.ok ? r.json() : null; });
        }).then(function (c3) {
          // Salió si la cantidad de packs bajó lo que se convirtió (puede quedar otra línea del mismo pack: el próximo
          // aviso del carrito la convierte).
          var salio = c3 && cantidadPack(c3, l.variant_id) <= antes - l.quantity;
          if (salio) { delete intentos[l.variant_id]; marcar(a.nombre || a.producto); }
          // Los frascos ya entraron pero el pack no salió: no se reintenta (otra vuelta duplicaría los frascos).
          else intentos[l.variant_id] = 99;
          try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
        });
      })
      .catch(function () {})
      .then(function () { ocupado = false; });
  }
  document.addEventListener('ff-escalera:carrito', function (e) { normalizar(e.detail); });

  // --- 3 y 4. Ficha de un pack ---
  // El producto de la escalera: el del formulario que la contiene (sirve también en la landing «razones»).
  function formDe(qb) {
    if (!qb) return null;
    var f = qb.closest('form');
    var i = !f && qb.querySelector('input[form]');
    return f || (i && document.getElementById(i.getAttribute('form'))) || null;
  }
  function productoDe(qb) {
    var f = formDe(qb);
    var i = f && f.querySelector('input[name="product-id"]');
    if (i && i.value) return String(i.value);
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    if (m && m.id) return String(m.id);
    var g = document.querySelector('form[action*="/cart/add"] input[name="product-id"]');
    return g ? String(g.value) : null;
  }
  function ficha() {
    var qbs = document.querySelectorAll('quantity-breaks');
    var lugares = qbs.length ? Array.prototype.slice.call(qbs) : [null];
    lugares.forEach(function (qb) {
      var a = porProducto[productoDe(qb) || ''];
      if (!a) return;
      document.documentElement.classList.add('ffa-ficha-pack');
      if (!a.regalo || !qb || qb.dataset.ffaRegalo) return;
      var todos = Object.keys(nombres);
      if (!todos.length) return;
      qb.dataset.ffaRegalo = '1';
      // Primero los hongos que no trae el dúo (el primero va marcado); después los del dúo, por si quiere repetir.
      var enDuo = a.variantes.map(String);
      var orden = todos.filter(function (v) { return enDuo.indexOf(v) < 0; }).concat(todos.filter(function (v) { return enDuo.indexOf(v) >= 0; }));
      regalo.pack = a; regalo.variante = orden[0];
      var caja = document.createElement('div');
      caja.className = 'ffa-regalo';
      // Compacto (03-11, Mau: «que se vea todo de un vistazo»): título y bajada en una línea, 4 botones en una fila.
      caja.innerHTML = '<p class="ffa-regalo__titulo" id="ffa-regalo-t">Elige tu hongo de regalo <span class="ffa-regalo__texto">· ' +
        (qb.querySelectorAll('label.quantity-break').length > 1 ? 'va incluido en la opción que elijas' : 'va incluido en tu pack') + '</span></p>' +
        '<div class="ffa-regalo__opciones" role="radiogroup" aria-labelledby="ffa-regalo-t">' + orden.map(function (v, i) {
          return '<button type="button" role="radio" class="ffa-regalo__op" aria-checked="' + (i === 0) + '" aria-label="' + nombres[v] + '" data-ffa-variante="' + v + '">' + String(nombres[v]).replace(/ de León$/, '') + '</button>';
        }).join('') + '</div>' +
        '<p class="ffa-regalo__aviso" role="status" hidden></p>';
      caja.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ffa-variante]');
        if (!b) return;
        regalo.variante = b.getAttribute('data-ffa-variante');
        avisoRegalo('');
        caja.querySelectorAll('[data-ffa-variante]').forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); });
      });
      regalo.caja = caja;
      qb.parentNode.insertBefore(caja, qb.nextSibling);
    });
  }

  var st = document.createElement('style');
  st.textContent =
    '.ffa-ficha-pack .shopify-payment-button{display:none!important}' +
    '.ffa-regalo{margin:10px 0 12px;padding:10px 12px;border-radius:14px;background:var(--ffp-pag-tinte,#F4EFE6);border:1px solid rgba(43,38,34,.08);letter-spacing:normal}' +
    '.ffa-regalo__titulo{margin:0 0 8px;font-weight:700;font-size:14px;line-height:1.3;color:var(--ffp-pag-tono,#2B2622)}' +
    '.ffa-regalo__texto{font-weight:500;font-size:12.5px;color:#5c534b}' +
    '.ffa-regalo__opciones{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:6px}' +
    '.ffa-regalo__op{min-height:38px;padding:4px 4px;border-radius:10px;border:1px solid rgba(43,38,34,.18);background:#fff;font:inherit;font-size:12.5px;font-weight:600;line-height:1.15;color:#2B2622;cursor:pointer;transition:border-color .2s,box-shadow .2s;white-space:normal;word-break:normal;hyphens:none}' +
    '.ffa-regalo__op:hover{border-color:#2B2622}' +
    '.ffa-regalo__op[aria-checked="true"]{border-color:var(--ffp-pag-tono,#2B2622);box-shadow:inset 0 0 0 1.5px var(--ffp-pag-tono,#2B2622);background:#fff}' +
    '.ffa-regalo__op[aria-checked="true"]::before{content:"✓ ";font-weight:700}' +
    '.ffa-regalo__op:focus-visible{outline:2px solid #2B2622;outline-offset:2px}' +
    // En celular el elegido se marca solo con el borde (el ✓ no cabe junto a «Cordyceps»); bajo 350 px, 2 columnas.
    '@media (max-width:420px){.ffa-regalo__op{font-size:12px;padding:4px 2px;letter-spacing:-.01em}.ffa-regalo__op[aria-checked="true"]::before{content:none}.ffa-regalo__op[aria-checked="true"]{box-shadow:inset 0 0 0 2px var(--ffp-pag-tono,#2B2622)}}' +
    '@media (max-width:350px){.ffa-regalo__opciones{grid-template-columns:repeat(2,minmax(0,1fr))}.ffa-regalo__op{min-height:34px}}' +
    '.ffa-regalo__aviso{margin:10px 0 0;font-size:13px;font-weight:600;color:#a3342b}';
  document.head.appendChild(st);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ficha);
  else ficha();
  // Escaleras que llegan después (landing «razones»). En las fichas la escalera ya está al cargar: no se vigila la página.
  function vigilarHastaEscalera(fn) {
    if (document.querySelector('quantity-breaks')) return;
    var espera = null;
    var obs = new MutationObserver(function (ms) {
      var nueva = ms.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && (n.tagName === 'QUANTITY-BREAKS' || (n.firstElementChild && n.querySelector('quantity-breaks'))); });
      });
      if (nueva) { obs.disconnect(); clearTimeout(espera); espera = setTimeout(fn, 120); }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { vigilarHastaEscalera(ficha); });
  else vigilarHastaEscalera(ficha);
  document.addEventListener('shopify:section:load', function () { setTimeout(ficha, 0); });

  window.FFAtajos = { esPack: esPack, cambiarCuerpo: cambiarCuerpo, ficha: ficha, _regalo: regalo, _porProducto: porProducto };
})();
